import {observable, observe} from "../../../../core/Observer.js";
import * as DashboardApi from "../../../../apiCall/dashboard/index.js";
import {subscribeWidget} from "../../../main-socket/index.js";
import {WIDGET} from "../../widgetConstants.js";

export class MemoWidget{
    timeout;
    constructor($target, $props = {}) {
        if ($target instanceof jQuery) {
            this.$target = $target[0];
            if ($target.length > 1) console.warn('Multi Elements!');
        } else {
            this.$target = $target;
        }
        if ($props) this.$props = $props;
        this.setup();
    }

    async setup(props) {
        if (!this.$target) return;

        await this.getData(props);
        this.render();
        this.setEvent();
        this.mounted();
    }

    async getData() {
        /*메모 api 호출부*/
        const memoData = await DashboardApi.getApi('memoController', {
            CRUD_GB: 'SELECT_ONE',
            USER_ID: _USER_ID,
            RGSR_ID: _USER_ID,
            RGSR_USE_INTT_ID: _USE_INTT_ID,
            WIDGET_USER_SRNO: this.$props.WIDGET_USER_SRNO,
        })
        this.$props.memoData = memoData.MEMO_REC[0];
        this.$props.data = this.convertToHtml(this.$props.memoData).trim();
        this.$props.tagData = '';    }

    render() {
        const _template = this.template();
        if (!_template) return;
        this.$target.innerHTML = _template;
    }

    template() {
        return `<div class="memo-widget js-upload-area" 
                     spellcheck="false" 
                     contenteditable="true"
                     data-memo-srno = ${this.$props.memoData.MEMO_SRNO}
                     placeholder="${i18next.t(common.input, {val: $t(dictionary.context)})}"
                     style="height: 100%;">${this.$props.data.trim()}</div>
                <div class="font-style-toolbar js-style-toolbar" style="display: none">
                    <button type="button" class="js-style-bold font-style-button">
                        <i class="icons-font-style bold"></i>
                    </button>
                    <button type="button" class="js-style-italic font-style-button">
                        <i class="icons-font-style italic"></i>
                    </button>
                    <button type="button" class="js-style-underline font-style-button">
                        <i class="icons-font-style underline"></i>
                    </button>
                    <button type="button" class="js-style-through font-style-button">
                        <i class="icons-font-style line-through"></i>
                    </button>
                </div>`
    }

    mounted() {
        $(this.$target).find('.widget-article-list').removeClass('dash-pending')
        $(this.$target).find('.dash-num-pending').remove()
        subscribeWidget({
            USER_ID : _USER_ID,
            TYPE : WIDGET.MEMO.SRNO
        })
    }

    setEvent() {
        const $inputArea = $(this.$target).find('.js-upload-area');
        $(this.$target).find('.memo-widget')
            .off("mousedown mouseup keydown keyup focusout")
            .on("mouseup", (e) => {
                StyleTag.initWidget($(this.$target));
                StyleTag.mouseUpCheck(e);
            })
            .on("keydown", (e) => {
                StyleTag.initWidget($(this.$target));
                StyleTag.keyDownCheck(e);
            })
            .on("keyup", (e) => {
                StyleTag.initWidget($(this.$target));
                StyleTag.keyUpCheck(e);

                //특정 브라우저에서만 <br>이 남는 이슈 발생하여 임시처리.
                if($inputArea.text().trim() === ""){
                    this.isEmpty = true; //모두 지웠을때는 공백이라도 업데이트 대상이 되어야하기 때문에 플래그 사용.
                }
            })
            .on("mousedown", (e) => {
                e.stopPropagation()
            })
            .on("focusout", (e) => {
                StyleTag.initWidget($(this.$target));
                StyleTag.closeStyleTagPopup();
                this.$props.tagData = JsonMaker.pullContentsTag($inputArea)
            })
        this.observer();
    }

    save(data) {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(async () => {
            const $uploadArea = $(this.$target).find('.js-upload-area');
            if ((this.isEmpty || data) && this.$props.memoData.CNTN !== data) {
                Mutil.clog("[옵저버 자동저장] " + data)
                await DashboardApi.getApi('memoController', {
                    CRUD_GB: 'UPDATE',
                    USER_ID: _USER_ID,
                    RGSR_ID: _USER_ID,
                    RGSR_USE_INTT_ID: _USE_INTT_ID,
                    MEMO_SRNO: this.$props.memoData.MEMO_SRNO,
                    WIDGET_USER_SRNO: this.$props.WIDGET_USER_SRNO,
                    CNTN: data
                })
                this.$props.memoData.CNTN = data;
            }
        }, 300)
    }

    observer() {
        observable(this.$props)
        observe((updateData) => {
            this.save(this.$props.tagData)
        });
    }

    convertToHtml(data) {
        let originHtml = '';
        const postComponentsJson = JsonMaker.str2json(JsonMaker.convertJsonString(data));
        postComponentsJson.forEach(function (component) {
            if (component.COMP_TYPE === "TEXT") {
                originHtml += TagConvert.db2HtmlStringByMemo(component.COMP_DETAIL.CONTENTS, 'EDIT')
            }
        })
        return originHtml
    }

}
